import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PairingBonusComponent} from './pairing-bonus/pairing-bonus.component';
import {SelfRePurchaseBonusComponent} from './self-re-purchase-bonus/self-re-purchase-bonus.component';
import {PerformanceBonusComponent} from './performance-bonus/performance-bonus.component';
import {LeadershipBonusComponent} from './leadership-bonus/leadership-bonus.component';
import {DirectorBonusComponent} from './director-bonus/director-bonus.component';
import {CarFundBonusComponent} from './car-fund-bonus/car-fund-bonus.component';
import {HouseFundBonusComponent} from './house-fund-bonus/house-fund-bonus.component';
import {TourFundBonusComponent} from './tour-fund-bonus/tour-fund-bonus.component';

const routes: Routes = [
    {
        path: 'pairing-bonus',
        component: PairingBonusComponent,
        data: {animation: 'pairing-bonus'}
    },
    {
        path: 'self-repurchase-bonus',
        component: SelfRePurchaseBonusComponent,
        data: {animation: 'self-repurchase-bonus'}
    },
    {
        path: 'performance-bonus',
        component: PerformanceBonusComponent,
        data: {animation: 'performance-bonus'}
    },
    {
        path: 'leadership-bonus',
        component: LeadershipBonusComponent,
        data: {animation: 'leadership-bonus'}
    },
    {
        path: 'director-bonus',
        component: DirectorBonusComponent,
        data: {animation: 'director-bonus'}
    },
    {
        path: 'car-fund-bonus',
        component: CarFundBonusComponent,
        data: {animation: 'car-fund-bonus'}
    },
    {
        path: 'house-fund-bonus',
        component: HouseFundBonusComponent,
        data: {animation: 'house-fund-bonus'}
    },
    {
        path: 'tour-fund-bonus',
        component: TourFundBonusComponent,
        data: {animation: 'tour-fund-bonus'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EarningRoutingModule {
}
